module.exports = __webpack_public_path__ + "static/media/expert.ce41d30e.png";